<template>
  <v-dialog
    v-model="visibility"
    max-width="500"
    persistent
  >
    <v-card class="px-0 py-2">
      <v-card-title class="headline pl-4 py-2 pr-2">
        Usuń rozliczenie
        <v-spacer></v-spacer>
        <v-btn
          @click.native="visibility = false"
          icon>
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="px-4">
        Czy na pewno chcesz usunąć rozliczenie?
      </v-card-text>

      <v-card-actions class="px-4">
        <v-spacer></v-spacer>

        <v-btn
          color="primary lighten-2"
          flat="flat"
          @click="setVisbility"
        >
          Anuluj
        </v-btn>

        <v-btn
          color="primary"
          :loading="busy"
          :disabled="busy"
          @click="deleteSub"
        >
          Ok
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'subscription-delete-dialog',
  data: () => ({
    busy: false,
  }),
  computed: {
    ...mapGetters('subscriptions', [
      'dialogVisibility',
    ]),
    visibility: {
      get() {
        return this.dialogVisibility.type === 'delete';
      },
      set(val) {
        this.setDialogVisbility(val);
      },
    },
    subscriptionId() {
      return this.dialogVisibility.id;
    },
    userId() {
      return this.$route.params.id;
    },
  },
  methods: {
    ...mapActions('subscriptions', [
      'setDialogVisbility',
      'subscriptionDelete',
    ]),
    setVisbility() {
      this.setDialogVisbility(false);
    },
    async deleteSub() {
      this.busy = true;
      await this.subscriptionDelete({
        subscriptionId: this.subscriptionId,
        userId: this.userId,
      });
      this.busy = false;
      this.setDialogVisbility(false);
    },
  },
};
</script>
